import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDropzoneModule } from 'ngx-dropzone';

import { HasPermissionDirective } from '../directives/permissions-directive.directive';
import { PrimengModule } from '../primeng/primeng.module';
import { AreasControlComponent } from './components/areas-control/areas-control.component';
import { AvatarNotificationComponent } from './components/avatar-notification/avatar-notification.component';
import { CarouselImagesComponent } from './components/carousel-images/carousel-images.component';
import { DialogErrorComponent } from './components/dialog-error/dialog-error.component';
import { FormAreasComponent } from './components/form-areas/form-areas/form-areas.component';
import { FormInspectionsComponent } from './components/form-areas/form-inspections/form-inspections.component';
import { FormStationsComponent } from './components/form-areas/form-stations/form-stations.component';
import { FormZonesComponent } from './components/form-areas/form-zones/form-zones.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MultipleFilesComponent } from './components/multiple-files/multiple-files.component';
import { OptionsDiagramTreeComponent } from './components/options-diagram-tree/options-diagram-tree.component';
import { ProfileDialogComponent } from './components/profile-dialog/profile-dialog.component';
import { SelectComponent } from './components/select/select.component';
import { AddUpdateAreaComponent } from './components/table-areas/components/add-update-area/add-update-area.component';
import { TableAreasComponent } from './components/table-areas/table-areas.component';
import { AddUpdateCheckPointComponent } from './components/table-check-point/components/add-update-check-point/add-update-check-point.component';
import { TableCheckPointComponent } from './components/table-check-point/table-check-point.component';
import { AddUpdatePerimeterComponent } from './components/table-perimeters/components/add-update-perimeter/add-update-perimeter.component';
import { TablePerimetersComponent } from './components/table-perimeters/table-perimeters.component';
import { AddUpdateStationsComponent } from './components/table-stations/components/add-update-stations/add-update-stations.component';
import { TableStationsComponent } from './components/table-stations/table-stations.component';
import { AddUpdateZoneComponent } from './components/table-zones/components/add-update-zone/add-update-zone.component';
import { TableZonesComponent } from './components/table-zones/table-zones.component';
import { TreeDiagramComponent } from './components/tree-diagram/tree-diagram.component';
import { UploadDocumentImageComponent } from './components/upload-document-image/upload-document-image.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { UploadComponent } from './components/upload/upload.component';

@NgModule({
  declarations: [
    DialogErrorComponent,
    LoadingComponent,
    ProfileDialogComponent,
    UploadFileComponent,
    SelectComponent,
    AreasControlComponent,
    FormZonesComponent,
    FormAreasComponent,
    FormStationsComponent,
    FormInspectionsComponent,
    TableZonesComponent,
    AddUpdateZoneComponent,
    TableAreasComponent,
    AddUpdateAreaComponent,
    TableStationsComponent,
    AddUpdateStationsComponent,
    UploadDocumentImageComponent,
    TableCheckPointComponent,
    TablePerimetersComponent,
    AddUpdatePerimeterComponent,
    AddUpdateCheckPointComponent,
    UploadComponent,
    CarouselImagesComponent,
    MultipleFilesComponent,
    TreeDiagramComponent,
    OptionsDiagramTreeComponent,
    AvatarNotificationComponent,
  ],
  imports: [
    CommonModule,
    // BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxDropzoneModule,
    PrimengModule,
    HasPermissionDirective
  ],
  exports: [
    MultipleFilesComponent,
    LoadingComponent,
    UploadFileComponent,
    SelectComponent,
    AreasControlComponent,
    TableZonesComponent,
    UploadDocumentImageComponent,
    UploadComponent,
    AvatarNotificationComponent,
    HasPermissionDirective
  ]
})
export class SharedModule { }
